function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { Constants, Environment } from './constants';
import datamapJson from '@appsource/datamapping/datamappingTaxonomy.json';
import { aiAppsAndAgentsEnabled } from '@shared/utils/aiAppsAndAgentsEnabled';
import { aiAppsAndAgentsDisabled } from '@shared/utils/aiAppsAndAgentsDisabled';
//TO DO - return after the new taxonomy rollout
//import oneTaxonomyDatamapJson from '@src/shared/oneTaxonomy/oneTaxonomyDatamapping.json';
import { isOneTaxonomyEnabled } from '@shared/oneTaxonomy/utils';
const MAX_BITMASK_INDEX = Math.pow(2, 30);
const CATEGORY_WITH_SUB_PREFIX = 'sub';
const URLGROUP_SEPERATOR_NAME = '_mask_';
const getDatamappingJsonFile = ()=>{
    //TO DO - return after the new taxonomy rollout
    // if (isOneTaxonomyEnabled()) {
    //   return oneTaxonomyDatamapJson.dataMappings;
    // }
    const isAIAgentEnabled = __APP_ENV__ === Environment.Canary;
    return _object_spread_props(_object_spread({}, datamapJson.dataMappings), {
        categories: _object_spread_props(_object_spread({}, datamapJson.dataMappings.categories), {
            default: _object_spread({}, datamapJson.dataMappings.categories.default, isAIAgentEnabled ? aiAppsAndAgentsEnabled : aiAppsAndAgentsDisabled)
        })
    });
};
var FilterType = /*#__PURE__*/ function(FilterType) {
    FilterType["product"] = "product";
    FilterType["category"] = "category";
    FilterType["industry"] = "industry";
    FilterType["cloudIndustries"] = "cloudIndustries";
    FilterType["serviceType"] = "serviceType";
    FilterType["filters"] = "filters";
    return FilterType;
}(FilterType || {});
const filterTypeToFilterGroup = {
    ["product"]: "product",
    ["category"]: "category",
    ["industry"]: "industry",
    ["cloudIndustries"]: Constants.CloudsIndustry.bitmaskPrefix + "industry",
    ["serviceType"]: "serviceType",
    ["filters"]: "filters"
};
const categoryFilterGroup = {
    products: "product",
    categories: "category",
    industries: "industry",
    cloudIndustries: "cloudIndustries",
    serviceTypes: "serviceType",
    pricingModel: "filters",
    ratings: "filters",
    appCompliance: "filters",
    AzureBenefitEligible: "filters",
    productType: "filters",
    CopilotExtension: "filters",
    operatingSystem: "filters",
    publisher: "filters"
};
const categoryUrlGroup = _object_spread_props(_object_spread({}, categoryFilterGroup), {
    cloudIndustries: "industry"
});
const subCategoryUrlGroup = _object_spread_props(_object_spread({}, Object.fromEntries(Object.keys(categoryFilterGroup).map((key)=>[
        key,
        key
    ]))), {
    cloudIndustries: Constants.DataMapCollectionKeys.industries
});
const productsToCategoriesReferences = {
    [Constants.CategoriesDataMapCollectionKeys.addIns]: [
        'analytics',
        'ai-plus-machine-learning',
        'collaboration',
        'Commerce',
        'compliance-and-legal',
        'customer-service',
        'finance',
        'geolocation',
        'human-resources',
        'internet-of-things',
        'it-and-management-tools',
        'marketing',
        'operations-and-supply-chain',
        'productivity',
        'task-and-project-management',
        'Sales',
        'ai'
    ],
    [Constants.CategoriesDataMapCollectionKeys.powerBiVisuals]: [
        'pbiv-comparison',
        'pbiv-correlation',
        'pbiv-distribution',
        'pbiv-flow',
        'Filters',
        'Infographics',
        'KPI',
        'pbiv-narratives',
        'Maps',
        'pbiv-other',
        'pbiv-part-to-whole',
        'pbiv-r-visuals',
        'Time'
    ],
    [Constants.CategoriesDataMapCollectionKeys.office]: [
        'analytics',
        'collaboration',
        'task-and-project-management',
        'Connectors',
        'customer-service',
        'finance',
        'human-resources',
        'it-and-management-tools',
        'marketing',
        'operations-and-supply-chain',
        'productivity',
        'Sales',
        'Utilities',
        'ContentManagement',
        'FileManagers',
        'CRM',
        'NewsWeather',
        'Reference',
        'SiteDesign',
        'Social',
        'TrainingAndTutorial'
    ]
};
const _getDatamappingJsonFile = getDatamappingJsonFile(), { categories: categoriesMapping } = _getDatamappingJsonFile, restMappings = _object_without_properties(_getDatamappingJsonFile, [
    "categories"
]);
export const DataMap = getDatamappingJsonFile();
const maskCounters = {};
const increaseMaskIndex = (currentMask)=>{
    currentMask.index *= 2;
    if (currentMask.index > MAX_BITMASK_INDEX) {
        currentMask.mask++;
        currentMask.index = 1;
    }
};
const calculateShortcutUrlKey = ({ ShortcutFilters, UrlKey })=>{
    if (ShortcutFilters) {
        return ShortcutFilters.map((currentShortcutUrl)=>{
            var _DataMap_products_;
            return (_DataMap_products_ = DataMap.products[`${currentShortcutUrl}`]) === null || _DataMap_products_ === void 0 ? void 0 : _DataMap_products_.UrlKey;
        }).join(';');
    }
    return UrlKey;
};
const getBaseFilterGroup = ({ mask, filterType })=>{
    return `${filterTypeToFilterGroup[filterType]}${URLGROUP_SEPERATOR_NAME}${mask}`;
};
const getFilterGroup = ({ dataCollectionKey, mask, filterType, isBaseFilterGroup })=>{
    const filterGroup = getBaseFilterGroup({
        mask,
        filterType
    });
    return isBaseFilterGroup ? filterGroup : categoryFilterGroup[`${dataCollectionKey}`];
};
const getDataValueBitMask = ({ dataCollectionKey, isBaseFilterGroup })=>{
    const currentMask = maskCounters[`${dataCollectionKey}`];
    const filterGroup = getFilterGroup({
        dataCollectionKey,
        filterType: categoryFilterGroup[`${dataCollectionKey}`],
        mask: currentMask.mask,
        isBaseFilterGroup
    });
    const filterInfo = {
        FilterGroup: filterGroup,
        FilterID: currentMask.index
    };
    return filterInfo;
};
const initDataValue = ({ dataValueKey, dataCollectionKey, dataValue, isBaseFilterGroup, isSubDataValue })=>{
    const currentMask = maskCounters[`${dataCollectionKey}`];
    const filterInfo = getDataValueBitMask({
        dataCollectionKey,
        isBaseFilterGroup
    });
    const { IsReference, SubCategoryDataMapping, IsChildFilter } = dataValue;
    if (dataCollectionKey === 'industries') {
        if (!IsReference) {
            increaseMaskIndex(currentMask);
        }
    } else if (!SubCategoryDataMapping && !IsReference) {
        increaseMaskIndex(currentMask);
    }
    Object.assign(dataValue, _object_spread_props(_object_spread({}, filterInfo), {
        UrlGroup: isSubDataValue ? `${CATEGORY_WITH_SUB_PREFIX}${subCategoryUrlGroup[dataCollectionKey]}` : categoryUrlGroup[`${dataCollectionKey}`],
        ShortcutUrlKey: calculateShortcutUrlKey(dataValue),
        IsChildFilter: IsChildFilter || isSubDataValue
    }));
};
const initMaskCounters = (dataCollectionKey)=>{
    if (!maskCounters[`${dataCollectionKey}`]) {
        maskCounters[`${dataCollectionKey}`] = {
            mask: 1,
            index: 1
        };
    }
};
const initCollection = ({ dataCollectionKey, dataCollection })=>{
    initMaskCounters(dataCollectionKey);
    Object.entries(dataCollection).forEach(([dataValueKey, dataValue])=>{
        initDataValue({
            dataValueKey,
            dataCollectionKey,
            dataValue,
            isBaseFilterGroup: dataCollectionKey === Constants.DataMapCollectionKeys.products,
            isSubDataValue: false
        });
        Object.values(dataValue.SubCategoryDataMapping || {}).forEach((subCategoryCollectionValue)=>{
            initDataValue({
                dataValueKey,
                dataCollectionKey,
                dataValue: subCategoryCollectionValue,
                isBaseFilterGroup: true,
                isSubDataValue: true
            });
        });
    });
};
const createCategoryReference = (id)=>{
    return {
        [`${id}`]: {
            IsReference: true,
            HideReferenceSubCategories: true
        }
    };
};
const updateCategoriesReferences = ()=>{
    const categoriesReference = Object.fromEntries(Object.entries(productsToCategoriesReferences).map(([productCategoryReference, productCategoryTaxonomy])=>{
        return [
            productCategoryReference,
            productCategoryTaxonomy.filter((uniqueFilter)=>DataMap.categories.default[`${uniqueFilter}`]).reduce((acc, productCategoryTaxonomy)=>_object_spread({}, acc, createCategoryReference(productCategoryTaxonomy)), {})
        ];
    }));
    DataMap.categories = _object_spread({}, DataMap.categories, categoriesReference);
};
const initDataMap = ()=>{
    const { categories } = DataMap, collections = _object_without_properties(DataMap, [
        "categories"
    ]);
    [
        ...Object.entries(collections),
        ...Object.values(categories).map((categoryCollection)=>[
                Constants.DataMapCollectionKeys.categories,
                categoryCollection
            ])
    ].forEach(([dataCollectionKey, dataCollection])=>{
        initCollection({
            dataCollectionKey,
            dataCollection
        });
    });
    if (isOneTaxonomyEnabled()) {
        updateCategoriesReferences();
    }
};
initDataMap();
